import { Sparkle28Filled } from "@fluentui/react-icons";

export const AnswerIcon = () => {
    return <Sparkle28Filled primaryFill={"#4285f4"} aria-hidden="true" aria-label="DNP Assistant" />;
};
